import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';

import NotificationsIcon from '@material-ui/icons/Notifications';
import AccountCircle from '@material-ui/icons/AccountCircle';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

const MenuMobile = ({ handleProfileMenuOpen, isMobileMenuOpen, handleMobileMenuClose, mobileMoreAnchorEl, MobileMenuId, numNotifications }) => {

    return (
        <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        id={MobileMenuId}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
    >
        <MenuItem>
            <IconButton aria-label={"show " + numNotifications + " new notifications"} >
                <Badge badgeContent={numNotifications}>
                    <NotificationsIcon color='primary' />
                </Badge>
            </IconButton>
            <p>Notifications</p>
        </MenuItem>
        <MenuItem onClick={handleProfileMenuOpen}>
            <IconButton
                aria-label="account of current user"
                aria-controls="primary-search-account-menu"
                aria-haspopup="true"
                color='primary'
            >
                <AccountCircle  color='primary'/>
            </IconButton>
            <p>Profile</p>
        </MenuItem>
    </Menu>
    )
};


export default MenuMobile;